import { render } from "./CurrentStatus.vue?vue&type=template&id=79820a5a&scoped=true"
import script from "./CurrentStatus.vue?vue&type=script&lang=js"
export * from "./CurrentStatus.vue?vue&type=script&lang=js"

import "./CurrentStatus.vue?vue&type=style&index=0&id=79820a5a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79820a5a"]])

export default __exports__